import React from 'react';
import DateCalendar from './DateCalendar';
import {getRenderComponent} from '../../react-input-wrapper';

const DateSelector = props => {
  let {
    value,
    onDateChange,
    renderInputSelector,
    inputSelectorContainerStyle,
    inputSelectorIconStyle,
    calendarStyle,
    ...rest
  } = props;
  if (renderInputSelector) {
    return getRenderComponent(renderInputSelector, props);
  }
  return (
    <DateCalendar
      {...rest}
      {...calendarStyle}
      iconContainerStyle={inputSelectorContainerStyle}
      value={value}
      onDateChange={onDateChange}
    />
  );
};

DateSelector.defaultProps = {
  inputSelectorContainerStyle: {
    paddingLeft: 8,
    paddingRight: 8,
    justifyContent: 'center',
  },
};

export default DateSelector;
